export const APP_CONFIG = {
  appName: "Malhotra's Property Portfolio",
  shortName: "MPP",
  version: "1.0.0-phase8",
};

export const NAV_LINKS = [
  { label: "Dashboard", path: "/", icon: "Grid" },
  { label: "Important Dates", path: "/important-dates", icon: "Calendar" },
  { label: "Properties", path: "/properties", icon: "Home" },
  { label: "Tenants", path: "/tenants", icon: "Users" },
  { label: "Rent Schedules", path: "/rent-schedules", icon: "Calendar" },
  { label: "Transactions", path: "/transactions", icon: "DollarSign" },
  { label: "Insurance", path: "/insurance", icon: "Shield" },
  { label: "Documents", path: "/documents", icon: "FileText" },
  { label: "Inspections", path: "/inspections", icon: "CheckSquare" },
  { label: "Open Items", path: "/open-items", icon: "AlertCircle" },
  { label: "Reports", path: "/reports", icon: "PieChart" },
  { label: "Settings", path: "/settings", icon: "Settings" },
];